import React, { createContext, useState } from "react";

export const SearchVectorLoadingContext = createContext(); 

export const SearchVectorLoadingProvider = ({ children }) => {
    const [searchVectorLoading, setSearchVectorLoading] = useState(false);

  return (
    <SearchVectorLoadingContext.Provider value={{ searchVectorLoading, setSearchVectorLoading }}>
      {children} 
    </SearchVectorLoadingContext.Provider>
  );
};
